import { render, staticRenderFns } from "./game-card.vue?vue&type=template&id=2cab89aa&scoped=true&"
import script from "./game-card.vue?vue&type=script&lang=js&"
export * from "./game-card.vue?vue&type=script&lang=js&"
import style0 from "./game-card.vue?vue&type=style&index=0&id=2cab89aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cab89aa",
  null
  
)

export default component.exports